/**
 * @flow
 * @relayHash 159bd9ac48ec1360e804a18458a96f03
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContemporaryLandingRespLayout_viewer$ref = any;
export type contemporaryLandingRootQueryVariables = {|
  contemporaryLandingPreviewId: string
|};
export type contemporaryLandingRootQueryResponse = {|
  +viewer: ?{|
    +contemporaryLanding: ?{|
      +metadata: ?{|
        +title: ?string,
        +description: ?string,
      |}
    |},
    +$fragmentRefs: ContemporaryLandingRespLayout_viewer$ref,
  |}
|};
export type contemporaryLandingRootQuery = {|
  variables: contemporaryLandingRootQueryVariables,
  response: contemporaryLandingRootQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contemporaryLandingPreviewId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "contemporaryLandingPreviewId",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "metadata",
  "storageKey": null,
  "args": null,
  "concreteType": "ContemporaryLandingMetadata",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cta",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtitle",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imagePath",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkPath",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "type": "ContemporaryLandingHeader",
  "selections": [
    (v15/*: any*/),
    (v9/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "contemporaryLandingRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContemporaryLandingRespLayout_viewer",
            "args": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contemporaryLanding",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ContemporaryLanding",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "contemporaryLandingRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contemporaryLanding",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ContemporaryLanding",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "modules",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "ContemporaryLandingVideo",
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "embedId",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "ContemporaryLandingRow",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "ContemporaryLandingFurnitureTileSection",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "caption",
                                "args": null,
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ContemporaryLandingRow",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingCategoryL2",
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "items",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ContemporaryLandingCategoryL3",
                                        "plural": true,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v10/*: any*/)
                                        ]
                                      },
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingMakerRowItem",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v15/*: any*/),
                                      (v9/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingHeroMakerRowItem",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "bgImagePath",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "location",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v14/*: any*/),
                                      (v9/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "userImagePath",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingFeaturedRowItem",
                                    "selections": [
                                      (v6/*: any*/),
                                      (v3/*: any*/),
                                      (v10/*: any*/),
                                      (v16/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingProductRowItem",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "brand",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "contemporaryTrackingString",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v10/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "itemPk",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "netPrice",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "retailPrice",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "ContemporaryLandingStyleRowItem",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v10/*: any*/),
                                      (v2/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v9/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "ContemporaryLandingSplashHeader",
                    "selections": [
                      (v6/*: any*/),
                      (v10/*: any*/),
                      (v16/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "contemporaryLandingRootQuery",
    "id": "app-buyer-misc/213.0.0-2019-04-24T16:13:25.915Z/contemporaryLandingRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e846d63abff26818be6e0b9d87c72f09';
module.exports = node;
